<template>
  <div>
    <layout-label
      text="パスワード"
      icon="lock-fill"
    />

    <b-form-group>
      <b-form-input
        type="password"
        v-model="model"
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import LayoutLabel from '@/lib/Layout/Label'

export default {
  components: {
    LayoutLabel
  },

  data () {
    return {
      modelName: 'login',
      attribute: 'password'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
